import { Injectable, inject } from '@angular/core';

import { USER_KEY } from '@core/auth/user-session.service';
import { WAREHOUSE_KEYS } from '@core/services/active-warehouse.service';
import { AppStorageService } from '@core/services/app-storage.service';
import { LOOKUPS_KEY } from '@core/services/lookup.service';

/** The keys the previous release wrote, and the key each one moved to. */
const MOVED: Readonly<Record<string, string>> = {
  user: USER_KEY,
  lookups: LOOKUPS_KEY,
  warehouseId: WAREHOUSE_KEYS.id,
  warehouseLocationId: WAREHOUSE_KEYS.locationId,
  warehouseName: WAREHOUSE_KEYS.name
};

/** Keys the previous release wrote that nothing reads any more. */
const DROPPED = ['warehouseCode', 'isWarehousePreferenceSaved', 'activeItem'];

/**
 * Carries a signed-in user's values from the previous release's key names over to the new ones, unchanged, once at
 * start-up before routing. It is the only code that names the old keys; delete it one week after it reaches
 * production.
 */
@Injectable({ providedIn: 'root' })
export class LegacyStorageBridge {
  private storage = inject(AppStorageService);

  run(): void {
    for (const [oldKey, newKey] of Object.entries(MOVED)) {
      const value = this.storage.get('local', oldKey);
      if (value === null) continue;
      if (this.storage.get('local', newKey) === null) {
        this.storage.set('local', newKey, value);
      }
      this.storage.remove('local', oldKey);
    }
    DROPPED.forEach(key => this.storage.remove('local', key));
  }
}
